import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'social_time'

const answers: AnswerType[] = [
  {
    emoji: '😶',
    title: 'pages.onboarding.socialTime.options.rarely',
    value: 'rarely',
  },
  {
    emoji: '📆',
    title: 'pages.onboarding.socialTime.options.fewTimesMonth',
    value: 'fewTimesMonth',
  },
  {
    emoji: '🤝',
    title: 'pages.onboarding.socialTime.options.weekly',
    value: 'weekly',
  },
  {
    emoji: '💙',
    title: 'pages.onboarding.socialTime.options.daily',
    value: 'daily',
  },
]

export default function SocialTimePage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && answers.some((answer) => answer.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()
  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const value = input.value

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How often do you spend time with other people?',
      answer_key: value,
      answer: value,
    }
    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.socialTime.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
